/*
 *
 *  sagas
 *
 */

import { call, take, put, race, select, all, delay } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_MY_CLIENT,
  ADD_PRODUCT_ASSIGN,
  ADD_TEAM_ASSIGN,
  LOAD_PRODUCTION_ASSIGN_HISTORY,
  ADD_CLEARANCE,
  UPDATE_CLIENT_COMPLETE,
  ADD_REACTIVE
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadClientComplete,
  loadClientCompleteSuccess,
  loadClientCompleteError,
  addProductAssignSuccess,
  addProductAssignError,
  addTeamAssignSuccess,
  addTeamAssignError,
  loadProductionAssignHistory,
  loadProductionAssignHistorySuccess,
  loadProductionAssignHistoryError,
  addClearanceError,
  addClearanceSuccess,
  addClearance,
  crmReset,
  updateClientCompleteSuccess,
  updateClientCompleteError,
  addReactiveSuccess,
  addReactiveError
} from "./actions"

import {
  loadClientCompleteApi,
  loadRecordsMetaData,
  addTeamAPI,
  addProductAPI,
  loadProductionAssignHistoryApi,
  addClearanceLevelDetails,
  updateClientCompleteApi,
  addReactiveApi
} from "./remotes"

import { selectSession } from "../session/selectors"
import { roleIds } from "../../helpers/tools"

function* loadClientCompleteSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_MY_CLIENT),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadClientComplete(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadClientCompleteApi, searchvalue)
        console.log("api result is", result)

        if (result) {
          yield put(loadClientCompleteSuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadClientCompleteSuccess([]))
          yield put(loadClientCompleteError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadClientCompleteSuccess([]))
        yield put(
          loadClientCompleteError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      let sessionDetails
      while (true) {
        // eslint-disable-line no-constant-condition
        const sessionInStore = yield select(selectSession())

        const { user = {} } = sessionInStore
        if (user && Object.keys(user).length > 0) {
          sessionDetails = sessionInStore
          break
        }
        yield delay(500)
      }

      let company
      let branch
      if (
        sessionDetails &&
        sessionDetails.user &&
        roleIds.includes(sessionDetails.user.roleId)
      ) {
        company = yield call(loadRecordsMetaData, "company", "post")
        branch = yield call(loadRecordsMetaData, "branch", "post")
      } else {
        company =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.company &&
            sessionDetails.user.company.length > 0 &&
            sessionDetails.user.company.map((_) => _.detail)) ||
          []
        branch =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.branch &&
            sessionDetails.user.branch.length > 0 &&
            sessionDetails.user.branch.map((_) => _.detail)) ||
          []
      }

     
      const processStatus = yield call(loadRecordsMetaData, "process_status", "post")
      const event = yield call( loadRecordsMetaData, "event", "post")
      const employee = yield call ( loadRecordsMetaData,
        "employee_dropdown_list",
        "post")
       
      let recordsMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          (company &&
            company.length > 0 &&
            company.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
          employeeOptions:
          (employee &&
            employee.data &&
            employee.data.length > 0 &&
            employee.data
             
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label:c.empCode.concat(" - ", c.name),
                    value: c._id,
                    
                  }
                )
              )) ||
          [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.name, value: c._id, companyId: c.companyId }
                )
              )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
       
        processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p._id,
                    processStatusId: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
          eventOptions:
          (event &&
            event.data &&
            event.data.length > 0 &&
            event.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.eventName,
                    value: c._id,
                    eventCode: c.eventCode,
                    //  companyId: c.companyId
                  }
                )
              )) ||
          [],
      }
      console.log(recordsMetaData, "my details")
      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* addTeamSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_TEAM_ASSIGN),
    })
    const { team_details } = create || {}
    if (create) {
     
      try {
        yield call(
          addTeamAPI,
          team_details
        )
          yield put(addTeamAssignSuccess(team_details))
        
      } catch (error) {
        yield put(
          addTeamAssignError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}

function* addProductSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_PRODUCT_ASSIGN),
    })
    const { product_details } = add || {}
    if (add) {
      try {
        yield call(addProductAPI, product_details)
        yield put(
          addProductAssignSuccess(
            product_details,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          addProductAssignError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadProductionAssignHistorySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_PRODUCTION_ASSIGN_HISTORY),
    })

    const { explicitLoad } = load

    const { historyPayload } = explicitLoad || {}
    yield put(loadProductionAssignHistory(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadProductionAssignHistoryApi, historyPayload)
        console.log("api result is", result)

        if (result) {
          yield put(loadProductionAssignHistorySuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadProductionAssignHistorySuccess([]))
          yield put(loadProductionAssignHistoryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadProductionAssignHistorySuccess([]))
        yield put(
          loadProductionAssignHistoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
function* addClearanceDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(ADD_CLEARANCE),
    })

    const { explicitLoad } = load

    const { applyClearance } = explicitLoad || {}
    yield put(addClearance(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(addClearanceLevelDetails, applyClearance)
        console.log("api result is", result)

        if (result) {
          yield put(addClearanceSuccess("Clearance Updated Successfully"))
          yield put(crmReset())
          console.log(result.data)
        } else {
         
          yield put(addClearanceError("Clearance Updated Failed"))
        }
      } catch (error) {
        yield put(
          addClearanceError(
            (error && error.response && error.response.message) ||
            "Clearance Updated Failed"
          )
        )
        yield put(crmReset())
      }
    }
  }
}

function* updateClientCompleteSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_CLIENT_COMPLETE),
    })
    const {client_data} = create || {}
    if (create) {
     
      try {
        yield call(
          updateClientCompleteApi,
          client_data
        )
          yield put(updateClientCompleteSuccess(client_data))
        
      } catch (error) {
        yield put(
          updateClientCompleteError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}

function* addReactiveSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_REACTIVE),
    })
    const { reactive_details } = create || {}
    if (create) {
     
      try {
        yield call(
          addReactiveApi,
          reactive_details
        )
          yield put(addReactiveSuccess(reactive_details))
        
      } catch (error) {
        yield put(
          addReactiveError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadClientCompleteSaga(),
    addProductSaga(),
    addTeamSaga(),
    loadProductionAssignHistorySaga(),
    addClearanceDetailsSaga(),
    updateClientCompleteSaga(),
   addReactiveSaga()
  ])
}
